import script from "./SolicitacoesClientesRepository.vue?vue&type=script&lang=js"
export * from "./SolicitacoesClientesRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__